import { useParams } from 'react-router-dom';
import ProjectGraph from './ProjectGraph';

/** The route element: keyed by the project id, so a move to another project's graph starts every view state afresh. */
export default function ProjectGraphRoute() {
  const { id } = useParams<{ id: string }>();
  return <ProjectGraph key={id} />;
}
